export const GroupClassroom = {
  Name: "Клас групи",
  Emoji: "👩‍🎓",
  EmptyForStudent: "Матеріали не додано",
  Empty: {
    LABEL: "Додайте підручник для групи",
    MESSAGE: "Групі не додано підручник для роботи.\nНатисніть +, щоб додати",
  },
  Add: {
    TITLE: "Додати підручник групі",
    EMOJI: "📚",
    SUBMIT: "Додати",
    Notification: {
      SUCCESS: "Підручник успішно доданий",
      ERROR: "Не вдалось додати підручник",
    },
    Empty: {
      MESSAGE: "Немає підручників... Додайте підручник, щоб дати групі роботу",
    },
  },
  Table: {
    Action: {
      VIEW: "Переглянути",
      PIN: "Закріпити",
      UNPIN: "Відкріпити",
    },
  },
  Hero: {
    Action: {
      BACK: "Повернутися до класу",
      UNPIN: "Відкріпити курс",
    },
  },
  LessonPreview: {
    Action: {
      BACK: "Повернутися назад",
      PIN: "Закріпити урок",
      UNPIN: "Відкріпити урок",
    },
  },
};
